export const isProductDisplayable = ({ isActive, isShow, isManageStock, stock, isOrderable } = {}) => {
  if (!isActive || !isShow || !isOrderable) return false;
  if (isManageStock) return !(stock <= 0);
  return true;
};

export const hasDisplayableProducts = ({ products } = {}) => {
  return (products ?? []).some(isProductDisplayable);
};
